import { render } from "./prescriptionPayment.vue?vue&type=template&id=544b603c&scoped=true"
import script from "./prescriptionPayment.vue?vue&type=script&lang=js"
export * from "./prescriptionPayment.vue?vue&type=script&lang=js"

import "./prescriptionPayment.vue?vue&type=style&index=0&id=544b603c&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544b603c"]])

export default __exports__